<template>
  <v-row justify="center">
    <v-dialog v-model="active" max-width="400">
      <v-card class="pa-3">
        <div class="close-dialog-btn mt-2" style="border-radius:14px">
          <v-icon size="28px" color="#D8DDE4" @click="close">mdi-close</v-icon>
        </div>
        <v-card-title class="text-h5 my-1" style="font-weight:800">
          請輸入報名密碼
        </v-card-title>
        <v-card-text class="text-left mt-1" style="font-weight:600; height:40px; font-size:15px">
          請索取密碼以方便您進行認證考試報名 
        </v-card-text>
        <v-text-field class="mx-14 mb-2 pt14" dense background-color="white" outlined placeholder="請輸入" style="border-radius:10px" v-model="passwd_keyIn">
        </v-text-field>     
        <p v-if="isError" class="warnning-text text-center ma-0 pt14">帳號密碼錯誤</p>

        <v-row justify="center">
          <v-card-actions>
            <v-btn outlined color="#FFF" style="width:200px; height:46px; border-radius:10px; background:#81C0E2"
            @click="save">
              下一步，前往報名
            </v-btn>
          </v-card-actions>
        </v-row>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    name:'ProjectPasswordInput',
    props:['onSave'],
    data () {
      return {
        active: false,
        isError: false,
        passwd: '',
        passwd_keyIn: '',
      }
    },
    methods:{
      open(passwd){
        this.active = true
        this.passwd = passwd
      },
      close(){
        this.active = false
      },
      save(){
        if(this.passwd == this.passwd_keyIn){
          this.onSave()
          this.close()
        } else {
          this.isError = true
        }
      }
    }
  }
</script>